import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as st from './bannerContainer.module.scss'
import * as cn from 'classnames'

type Props = {
  isRetail: boolean
}

export class BannerContainer extends React.Component<Props> {
  private portalRoot: HTMLElement | null | undefined

  constructor(props: Props) {
    super(props)
  }

  componentDidMount() {
    this.portalRoot = document.getElementById('av-dp-banner-root')
  }

  render() {
    const { isRetail, children } = this.props
    if (!this.portalRoot) {
      return null
    }

    // TODO(AVWebDetailPage-3618): React Portal should be removed once Amabot is launched
    return ReactDOM.createPortal(
      <div className={cn(st.bannerContainer, { [st.sticky]: !isRetail })}>
        {children}
      </div>,
      this.portalRoot
    )
  }
}
